import React from 'react';
import styled from '@emotion/styled';

const ThreeDotsImg = styled.img<{ h?: number | undefined }>`
  display: block;
  height: ${({ h = 3 }) => `${h}px`};
  width: auto;
`;

type ThreeDotsProps = {
  h?: number;
};

export const ThreeDots: React.FC<ThreeDotsProps> = ({ h }) => {
  return <ThreeDotsImg h={h} src="/threedots.svg" alt="menu" />;
};
